import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: "field-set-min-activities",
  templateUrl: "./field-set-min-activities.component.html",
  styles: [],
})
export class FieldSetMinActivitiesComponent {

  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }
}
